import React from 'react'
import {Icon} from '@chakra-ui/react'

const FastCartIcon = (props) => {
    return (
        <Icon viewBox="0 0 48 48" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.94037 7.73992H10.6129L16.6742 31.2106C16.7868 31.6466 17.1767 31.9508 17.6229 31.9508H39.763C40.1797 31.9508 40.5508 31.6848 40.6884 31.2877L46.9842 13.114C47.2071 12.4703 46.734 11.7971 46.0587 11.7971H13.687L12.3191 6.50017C12.2065 6.06422 11.8166 5.76001 11.3704 5.76001H1.94037C1.3989 5.76001 0.959961 6.20323 0.959961 6.74997C0.959961 7.2967 1.3989 7.73992 1.94037 7.73992ZM18.3805 29.9709L14.1984 13.777H44.6771L39.0673 29.9709H18.3805Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.2383 42.24C17.9011 42.24 16.0065 40.3555 16.0065 38.0308C16.0065 35.7061 17.9011 33.8215 20.2383 33.8215C22.5755 33.8215 24.4702 35.7061 24.4702 38.0308C24.4702 40.3555 22.5755 42.24 20.2383 42.24ZM20.2383 40.5563C21.6406 40.5563 22.7774 39.4256 22.7774 38.0308C22.7774 36.636 21.6406 35.5052 20.2383 35.5052C18.836 35.5052 17.6992 36.636 17.6992 38.0308C17.6992 39.4256 18.836 40.5563 20.2383 40.5563Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37.1657 42.24C34.8285 42.24 32.9338 40.3555 32.9338 38.0308C32.9338 35.7061 34.8285 33.8215 37.1657 33.8215C39.5029 33.8215 41.3975 35.7061 41.3975 38.0308C41.3975 40.3555 39.5029 42.24 37.1657 42.24ZM37.1657 40.5563C38.568 40.5563 39.7048 39.4256 39.7048 38.0308C39.7048 36.636 38.568 35.5052 37.1657 35.5052C35.7634 35.5052 34.6266 36.636 34.6266 38.0308C34.6266 39.4256 35.7634 40.5563 37.1657 40.5563Z"
                fill="currentColor"
            />
            <path
                d="M4.72159 17.92C4.72159 18.4366 5.14263 18.8554 5.662 18.8554H10.364C10.8834 18.8554 11.3045 18.4366 11.3045 17.92C11.3045 17.4034 10.8834 16.9846 10.364 16.9846H5.662C5.14263 16.9846 4.72159 17.4034 4.72159 17.92Z"
                fill="currentColor"
            />
            <path
                d="M3.78119 23.5323C3.26181 23.5323 2.84078 23.1135 2.84078 22.5969C2.84078 22.0803 3.26181 21.6615 3.78119 21.6615H10.364C10.8834 21.6615 11.3044 22.0803 11.3044 22.5969C11.3044 23.1135 10.8834 23.5323 10.364 23.5323H3.78119Z"
                fill="currentColor"
            />
            <path
                d="M0.959961 27.2739C0.959961 27.7905 1.381 28.2092 1.90037 28.2092H10.364C10.8834 28.2092 11.3044 27.7905 11.3044 27.2739C11.3044 26.7573 10.8834 26.3385 10.364 26.3385H1.90037C1.381 26.3385 0.959961 26.7573 0.959961 27.2739Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default FastCartIcon
